{
  "about.blocks": "Moderowane serwery",
  "about.contact": "Kōntakt:",
  "about.disclaimer": "Mastodon je wolne a ôtwartozdrzōdłowe ôprogramowanie i towarowy znak ôd Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Brak prziczyny",
  "about.domain_blocks.preamble": "Mastodon z wiynksza dŏwŏ ôglōndać treści i kōmunikować sie ze używŏczami inkszych serwerōw we fediverse. To sōm wyjōntki, co fungujōm na tym kōnkretnym serwerze.",
  "about.domain_blocks.silenced.explanation": "Normalniy niy bydziesz widzieć profilōw a treściōw ze tygo serwera. Ôboczysz je ino jak specjalniy bydziesz ich szukać abo jak je zaôbserwujesz.",
  "about.domain_blocks.silenced.title": "Ôgraniczone",
  "about.domain_blocks.suspended.explanation": "Żŏdne dane ze tygo serwera niy bydōm przetwarzane, przechowywane abo wymieniane, beztoż wszelakŏ interakcyjŏ abo komunikacyjŏ ze używŏczami tygo serwera bydzie niymożliwŏ.",
  "about.domain_blocks.suspended.title": "Zawiyszōne",
  "about.not_available": "Ta informacyjŏ niy bōła udostympniōna na tym serwerze.",
  "about.rules": "Zasady serwera",
  "account.badges.bot": "Bot",
  "account.badges.group": "Grupa",
  "account.block": "Zablokuj @{name}",
  "account.block_domain": "Zablokuj domena {domain}",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.media": "Media",
  "account.mute": "Wycisz @{name}",
  "account.posts": "Posty",
  "account_note.placeholder": "Wybier, żeby przidac notka",
  "column.bookmarks": "Zokłodki",
  "column.direct": "Prywatne spōmniynia",
  "column.favourites": "Spamiyntane",
  "column.firehose": "Kanały na żywo",
  "column.home": "Przodek",
  "column.lists": "Wykazy",
  "column.notifications": "Uwiadōmiynia",
  "column.pins": "Pinned toot",
  "community.column_settings.media_only": "Ino media",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.placeholder": "Co nowego?",
  "compose_form.publish": "Wyślij",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "explore.title": "Popularne",
  "explore.trending_links": "Nowiny",
  "explore.trending_statuses": "Posty",
  "explore.trending_tags": "Etykety",
  "followed_tags": "Torowane etykety",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "navigation_bar.bookmarks": "Zokłodki",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.more": "Wiyncyj",
  "navigation_bar.preferences": "Sztalōnki",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notifications.column_settings.status": "New toots:",
  "privacy.change": "Adjust status privacy",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.search_or_paste": "Szukej abo wraź URL",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.copy": "Copy link to status",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Prawie popularne",
  "upload_progress.label": "Uploading…"
}
